import { IconWithLabel } from '@/components/atomic/atoms';

const showStatus = false;

const ProfileCard = ({ designation, mobileNumber, name }) => (
  <div
    className={`w-full flex flex-col p-4 border border-pink-200 rounded-lg hover:border-pink-300 shadow hover:shadow-lg transition-all duration-300`}
  >
    <div className='w-full flex flex-row justify-between'>
      <div className='flex flex-col'>
        <div className='text-base md:text-xl font-medium'>{name ?? 'N/A'}</div>
        <div className='text-xs md:text-sm'>{designation ?? 'N/A'}</div>
      </div>
      {showStatus && (
        <div className='flex flex-row gap-2 bg-green-200 rounded-full items-center px-3 py-1 h-max'>
          <div className='w-3 h-3 bg-green-800 rounded-full' />
          <div className='text-[10px] md:text-xs font-medium text-green-800'>
            Partner Status
          </div>
        </div>
      )}
    </div>
    <div className='w-full flex flex-row mt-3'>
      <IconWithLabel
        {...{
          containerClass: 'flex gap-2',
          imgAlt: 'phone',
          imgSrc: 'phone-red-icon.svg',
          value: mobileNumber ?? 'N/A',
          valueStyle: 'text-sm md:text-base font-medium self-center'
        }}
      />
    </div>
  </div>
);

const ProfileBody = ({ partnerUsersByPartnerOrgId }) => (
  <div className='w-full max-w-7xl mx-auto px-4 md:px-0 mb-4'>
    <div className='text-base md:text-xl font-medium md:mt-6 mt-5'>
      Team Members
    </div>
    <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mt-4'>
      {partnerUsersByPartnerOrgId.map(
        ({ designation, id, mobileNumber, name }) => (
          <ProfileCard
            key={id}
            {...{
              designation,
              mobileNumber,
              name
            }}
          />
        )
      )}
    </div>
  </div>
);

export default ProfileBody;
